export default __webpack_public_path__ + "static/media/icon_arrow_right_white.db4b886a.svg";